"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GooglePayCreditCardNetworks = exports.ApplePayCreditCardNetworks = exports.PaymentMethodType = void 0;
const PaymentMethod_1 = require("@wix/cashier-common/dist/src/enums/payments/PaymentMethod");
var PaymentMethodType;
(function (PaymentMethodType) {
    PaymentMethodType["Undefined"] = "UNDEFINED";
    PaymentMethodType["Online"] = "ONLINE";
    PaymentMethodType["FaceToFace"] = "FACE_TO_FACE";
})(PaymentMethodType = exports.PaymentMethodType || (exports.PaymentMethodType = {}));
// https://developer.apple.com/documentation/apple_pay_on_the_web/applepaypaymentrequest/1916122-supportednetworks
var ApplePayCreditCardNetworks;
(function (ApplePayCreditCardNetworks) {
    ApplePayCreditCardNetworks["Amex"] = "AMEX";
    ApplePayCreditCardNetworks["CartesBancaires"] = "CARTES_BANCAIRES";
    ApplePayCreditCardNetworks["ChinaUnionPay"] = "CHINA_UNION_PAY";
    ApplePayCreditCardNetworks["Discover"] = "DISCOVER";
    ApplePayCreditCardNetworks["Eftpos"] = "EFTPOS";
    ApplePayCreditCardNetworks["Electron"] = "ELECTRON";
    ApplePayCreditCardNetworks["Elo"] = "ELO";
    ApplePayCreditCardNetworks["Interac"] = "INTERAC";
    ApplePayCreditCardNetworks["Jcb"] = "JCB";
    ApplePayCreditCardNetworks["Mada"] = "MADA";
    ApplePayCreditCardNetworks["Maestro"] = "MAESTRO";
    ApplePayCreditCardNetworks["MasterCard"] = "MASTER_CARD";
    ApplePayCreditCardNetworks["PrivateLabel"] = "PRIVATE_LABEL";
    ApplePayCreditCardNetworks["Visa"] = "VISA";
    ApplePayCreditCardNetworks["VPAY"] = "VPAY";
})(ApplePayCreditCardNetworks = exports.ApplePayCreditCardNetworks || (exports.ApplePayCreditCardNetworks = {}));
var GooglePayCreditCardNetworks;
(function (GooglePayCreditCardNetworks) {
    GooglePayCreditCardNetworks["Amex"] = "AMEX";
    GooglePayCreditCardNetworks["Discover"] = "DISCOVER";
    GooglePayCreditCardNetworks["Interac"] = "INTERAC";
    GooglePayCreditCardNetworks["Jcb"] = "JCB";
    GooglePayCreditCardNetworks["MasterCard"] = "MASTER_CARD";
    GooglePayCreditCardNetworks["Visa"] = "VISA";
    GooglePayCreditCardNetworks["Electron"] = "ELECTRON";
    GooglePayCreditCardNetworks["Elo"] = "ELO";
    GooglePayCreditCardNetworks["EloDebit"] = "ELO_DEBIT";
    GooglePayCreditCardNetworks["Maestro"] = "MAESTRO";
})(GooglePayCreditCardNetworks = exports.GooglePayCreditCardNetworks || (exports.GooglePayCreditCardNetworks = {}));
//# sourceMappingURL=types.js.map